import ReactOnRails from 'react-on-rails';

import { RegistrationsSchoolInfoForm } from 'bundles/registrations/members';

ReactOnRails.register({
  RegistrationsSchoolInfoForm: RegistrationsSchoolInfoForm
});
